import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'core/ui/Box';
import DatePickerRounded from 'core/ui/DatePickers/DatePickerRounded';
import { ButtonPrimarySm } from 'core/ui/Button';
import { Search } from '@material-ui/icons';
import { formatDate, formatDateToApi } from 'core/utils/formatters';
import useActions from 'modules/map/useActions';
import Modules from 'modules';
import useSelectors from 'modules/map/useSelectors';
import { adminChannelsModule } from 'modules/admin/channels';
import TextFieldRounded from 'core/ui/TextFieldRounded';
import SelectBox from 'core/ui/SelectBox';
import Checkbox from 'core/ui/Checkbox';
import TableLogs from './Table';

export const auditedModels = [
  'ChannelKey',
  'Channel',
  'ChannelMembershipPlan',
  'ChannelMembershipCoupon',
  'Workout',
  'WorkoutsUser',
  'PartnersProgramsChannel',
  'User',
];

const AuditedLogsReport = ({ auditableId, auditableType }) => {
  const { t } = useTranslation();
  const { request } = useActions();
  const loadingLogs = useSelectors(adminChannelsModule, 'loadingLogs');
  const [data, setData] = useState([]);
  const dateNow = new Date();
  const [filters, setFilters] = useState({
    startAt: `${dateNow.getMonth() + 1}/1/${dateNow.getFullYear()}`,
    endAt: formatDate(new Date(), 'MM/DD/YYYY'),
    auditableType: 'ChannelKey',
  });

  const getLogs = (params) => {
    if (!params.auditableType) {
      alert('Please add a object type.');
      return;
    }

    request({
      action: Modules.adminChannels.actions.getAuditLogs,
      data: auditableId ? { auditableId, auditableType, skipDate: true } : { ...params },
      options: {
        onSuccess: (resp) => {
          setData(resp);
        },
      },
    });
  };

  const search = () => {
    const startAt = filters.startAt ? formatDateToApi(filters.startAt) : null;
    const endAt = filters.endAt ? formatDateToApi(filters.endAt) : null;
    if (startAt && endAt) getLogs({ ...filters, startAt, endAt });
  };

  useEffect(() => {
    if (auditableId && auditableType) {
      search();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auditableId, auditableType]);

  return (
    <Box>
      {!auditableId && (
        <Box display="flex" mb={3} alignItems="flex-end" justifyContent="center" flexWrap="wrap">
          <Box>
            <TextFieldRounded
              label="User ID"
              onChange={(v) => setFilters((prev) => ({ ...prev, userId: v }))}
              value={filters.userId}
              disablePast={false}
              autoOk
            />
          </Box>
          <Box ml={1}>
            <TextFieldRounded
              label="Object ID"
              onChange={(v) => setFilters((prev) => ({ ...prev, auditableId: v }))}
              value={filters.auditableId}
              disablePast={false}
              autoOk
            />
          </Box>
          <Box ml={1} style={{ minWidth: 150 }}>
            <SelectBox
              label="Object Type"
              options={auditedModels}
              setValue={(v) => setFilters((prev) => ({ ...prev, auditableType: v }))}
              value={filters.auditableType}
            />
          </Box>
          <Box mx={2}>
            <Checkbox
              label="Skip Date"
              checked={filters.skipDate}
              onClick={() => setFilters((prev) => ({ ...prev, skipDate: !prev.skipDate }))}
            />
          </Box>
          {!filters.skipDate && (
            <>
              <Box ml={1}>
                <DatePickerRounded
                  label={t('channel.reports.filter.start').toUpperCase()}
                  onChange={(v) => setFilters((prev) => ({ ...prev, startAt: v }))}
                  value={filters.startAt}
                  disablePast={false}
                  autoOk
                />
              </Box>
              <Box ml={1}>
                <DatePickerRounded
                  label={t('channel.reports.filter.end').toUpperCase()}
                  onChange={(v) => setFilters((prev) => ({ ...prev, endAt: v }))}
                  value={filters.endAt}
                  disablePast={false}
                  autoOk
                />
              </Box>
            </>
          )}
          <Box ml={3}>
            <ButtonPrimarySm disabled={loadingLogs} onClick={() => search()}>
              <Search style={{ color: 'white' }} fontSize="small" />
              {t('button.search')}&nbsp;
            </ButtonPrimarySm>
          </Box>
        </Box>
      )}

      <TableLogs refresh={search} loading={loadingLogs} logs={data?.logs} />
    </Box>
  );
};

export default AuditedLogsReport;
